export const adminListApplications = `query adminListApplications {
  adminListApplications{
    applicationId
    type
    group
    name
    label
    description
    version
    active
    adminOnly
  }
}`;

export const adminGetApplication = `query adminGetApplication($applicationId: ID!) {
  adminGetApplication(applicationId: $applicationId){
      applicationId
      type
      group
      name
      label
      description
      version
      active
      adminOnly
      parameters
      buildId
      users
      modules {
        name
        filename
      }
      aam
      env {
        key
        value
      }
  }
}`;

export const userListApplications = `query userListApplications {
  userListApplications{
    applicationId
    type
    group
    name
    label
    description
    version
    active
    adminOnly
  }
}`;

export const userGetApplication = `query userGetApplication($applicationId: ID!) {
  userGetApplication(applicationId: $applicationId){
      applicationId
      accountId
      type
      group
      name
      label
      description
      version
      active
      adminOnly
      parameters
      buildId
  }
}`;
